import gql from 'graphql-tag';

export const DetailsPanelContentLabelDeleteMutation = gql`
	mutation DetailsPanelContentLabelDeleteMutation($contentId: ID!, $label: String!) {
		deleteLabel(input: { contentId: $contentId, label: $label }) {
			contentId
		}
	}
`;
